

export default {
    cptDataForm: {
        dataText: '{"value":"普通文本"}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute: {
        defaultValueType: null, defaultValue: '',
        textColor: '#fff', textSize: 12,
        enableGradual: 1, gradualColor: ['#54f857', '#f31794'],
        fontWeight: 'normal', textLineHeight: 30, letterSpacing: 0,
        textFamily: '微软雅黑', textAlign: 'center',
        fontStyle: 'normal', textDecoration: 'none', bgColor: 'rgba(255, 255, 255, 0)',
        borderRadius: 0, borderStyle: 'none', borderWidth: 1, borderColor: '#ccc',
        alarmConfig: {
            operator: '>',
            threshold: '',
            textColor: '#f00',
            bgColor: ''
        },
        amountTo: null,
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        isEllipsis: 0,
        lineClamp: 1,
        funcResult: null,
        sqlSetValue: 0,
        sqlSetValueColor: '',
        isScale: 0
    },

}